module.exports = __webpack_public_path__ + "img/brain.fe407a5c.png";